<template>
  <div>
    <div class="card spinner" v-if="$store.state.loader > 0">
      <ProgressSpinner />
    </div>
    <section id="container">
      <HeaderSideBar
        :is_not_expand="is_not_expand"
        @call="expand()"
        v-if="show_sidebar"
      />
      <div :class="[getClassName(), { 'no-margin': isPreviewShownPopup }]">
        <router-view @toggle-preview="handleTogglePreview" />
      </div>
      <!-- <ToastMessage /> -->
      <section
        id="main-content"
        v-if="
          $route.name !== 'Login' &&
          $route.name !== 'Blank' &&
          $route.name !== 'ForgotPassword' &&
          $route.name !== 'ResetPassword' &&
          $route.name !== 'ChangePassword' &&
          $route.name !== 'ManageDealUpdateById' &&
          $route.name !== 'ManageDealUpdateCreate' &&
          $route.name !== 'copydeal' &&
          showFooter
        "
      >
        <!-- <footer class="site-footer">
          <div class="text-center">
            {{ new Date().getFullYear() }} &copy; Voyado AB
          </div>
        </footer> -->
      </section>
      <section
        id="footer-change"
        v-if="
          ($route.name == 'ManageDealUpdateById' ||
            $route.name == 'ManageDealUpdateCreate') &&
          showFooter
        "
      >
        <!-- <footer class="site-footer">
          <div class="text-center">
            {{ new Date().getFullYear() }} &copy; Voyado AB
          </div>
        </footer> -->
      </section>
    </section>
    <ToastMessage :key="Date.now()" />
    <!-- <PrimeToast /> -->
  </div>
</template>

<script>
import HeaderSideBar from "@/components/layout/HeaderSidebarNew.vue";
import DataLayerService from "@/services/data-layer.service";

export default {
  components: {
    HeaderSideBar,
  },
  data() {
    return {
      renderKey: 0,
      is_not_expand: false,
      isPreviewShownPopup: false,
      showParam: null,
      changeRef: false,
      show_sidebar: true,
      showFooter: false,
      messageListener: null,
    };
  },
  watch: {
    "$store.state.loader": {
      handler(newValue) {
        document.querySelector("body").style.overflow =
          newValue > 0 ? "hidden" : "auto";
      },
      immediate: true,
    },
    $route() {
      this.changeRef = false;
      this.updateUrlParamsFromRoute(); // Update store with current route params
    },
  },
  mounted() {
    window.addEventListener("error", (e) => {
      if (e.message.includes("404")) {
        this.$router.push({ name: "Login" });
      }
    });
    this.setupAuth0Listener();
    this.updateUrlParamsFromRoute(); // Initial update on mount
  },
  beforeUnmount() {
    if (this.messageListener) {
      window.removeEventListener("message", this.messageListener);
    }
  },
  updated() {
    if (
      this.$route.name !== undefined &&
      this.$route.name !== null &&
      this.$route.name !== "" &&
      this.changeRef == false
    ) {
      const queryParams = new URLSearchParams(window.location.search);
      const showParam = queryParams.get("show");
      const hideMenu = queryParams.get("hide");
      const newQuery = {};

      queryParams.forEach((value, key) => {
        newQuery[key] = value;
      });

      this.show_sidebar = true;
      this.is_not_expand = false;
      this.showFooter = true;

      const routesWithoutSidebar = [
        "Login",
        "Blank",
        "ForgotPassword",
        "ResetPassword",
        "ChangePassword",
        "copydeal",
        "essence",
      ];
      if (routesWithoutSidebar.includes(this.$route.name)) {
        this.show_sidebar = false;
        this.is_not_expand = false;
        this.showFooter = false;
      }

      if (showParam === "deallistnew") {
        this.$router.push({ name: "ManageDealList", query: newQuery });
        this.is_not_expand = true;
        this.show_sidebar = false;
        this.expand();
      } else if (showParam === "deallist" || showParam === "deallis") {
        if (this.$route.name !== "ManageDealListNew") {
          this.$router.push({ name: "ManageDealListNew", query: newQuery });
        }
        this.is_not_expand = true;
        this.show_sidebar = false;
        this.expand();
      }

      if (hideMenu === "menu") {
        this.show_sidebar = false;
        this.is_not_expand = false;
        this.expand();
      }

      if (
        this.$route.name === "ManageDealUpdateById" ||
        this.$route.name === "ManageDealUpdateCreate"
      ) {
        this.showFooter = true;
      }

      this.changeRef = true;
    }
  },
  methods: {
    inIframe() {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    },
    expand() {
      this.is_not_expand = !this.is_not_expand;
    },
    handleTogglePreview() {
      if (this.isPreviewShownPopup == true) {
        this.isPreviewShownPopup = false;
        this.show_sidebar = true;
      } else {
        this.isPreviewShownPopup = true;
        this.show_sidebar = false;
      }
    },
    getClassName() {
      if (this.inIframe()) {
        this.show_sidebar = false;
        this.is_not_expand = false;
        return "in-iframe";
      } else if (this.is_not_expand) {
        return "not-expand";
      } else if (
        this.$route.name !== "Login" &&
        this.$route.name !== "ForgotPassword" &&
        this.$route.name !== "ResetPassword" &&
        this.$route.name !== "ChangePassword" &&
        this.$route.name !== "copydeal" &&
        this.$route.name !== "essence" &&
        this.$route.name !== "Blank"
      ) {
        return "expand";
      }
      return "";
    },
    setupAuth0Listener() {
      console.log("Setting up logout listener");

      const onMsg = (e) => {
        console.log(
          "App: Received message",
          e,
          "and",
          e.data,
          "and",
          this.$store.state.origin
        );

        if (
          e.data &&
          typeof e.data === "object" 
          // &&
          // e.origin === this.$store.state.origin
        ) {
          console.log(
            "App: Valid message from trusted origin",
            e.origin,
            e.data,
            // this.$store.state.origin
          );

          const { type } = e.data;
          if (type === "LOGOUT") {
            console.log("App: Logging out");
            // const targetOrigin = this.$store.state.origin || "*"; // Fallback to "*" if origin is empty
            const accessToken = this.$store.state.accesstoken;
            const refreshToken = this.$store.state.refreshtoken;
            const email = this.$store.state.cognitoInfo.email;

            if (accessToken && refreshToken && email) {
              try {
                const payload = { accessToken, refreshToken, email };
                DataLayerService.post("/auth/Logout", payload);
              } catch (error) {
                console.error("Logout API call failed:", error);
              }
            }
            this.$store.commit("resetOnLogout");
            window.parent.postMessage({ type: "LOGOUT_ACK" }, e.origin);
            
            console.log(
              "Sending LOGOUT_ACK to parent window, origin:",
              e.origin
            );

            // Navigate to Blank page after timeout
            setTimeout(() => {
              console.log("Navigating to Blank page after timeout");
              this.$router.push({ name: "Blank" });
            }, 2000); // 2000ms = 2 second delay
          }
          // else if (type === "LOGOUT_ACK") {
          //   console.log("App: Child acknowledged logout");
          //   this.$store.commit("resetOnLogout");
          //   this.$router.push({ name: "Login" });
          // }
        }
      };

      this.messageListener = onMsg;
      window.addEventListener("message", this.messageListener);
    },
    updateUrlParamsFromRoute() {
      const queryParams = new URLSearchParams(window.location.search);
      const params = {
        tenant: queryParams.get("tenant"),
        origin: queryParams.get("origin"),
        email: queryParams.get("email"),
        language: queryParams.get("language"),
        expectedIssuer: queryParams.get("expectedIssuer"),
        expectedAudience: queryParams.get("expectedAudience"),
        organization: queryParams.get("organization"),
        connection: queryParams.get("connection"),
      };

      // Commit only if params differ from current store state to avoid unnecessary updates
      if (params.origin !== this.$store.state.origin) {
        this.$store.commit("setOrigin", params.origin);
      }
      if (params.tenant !== this.$store.state.tenant) {
        this.$store.commit("setTenant", params.tenant);
      }
      if (params.language !== this.$store.state.language) {
        this.$store.commit("setLanguage", params.language);
      }
      if (params.expectedIssuer !== this.$store.state.expectedIssuer) {
        this.$store.commit("setExpectedIssuer", params.expectedIssuer);
      }
      if (params.expectedAudience !== this.$store.state.expectedAudience) {
        this.$store.commit("setExpectedAudience", params.expectedAudience);
      }
      if (params.organization !== this.$store.state.organization) {
        this.$store.commit("setOrganization", params.organization);
      }
      if (params.connection !== this.$store.state.connection) {
        this.$store.commit("setConnection", params.connection);
      }

      // Check for email mismatch and redirect to Login if different
      const storedEmail = this.$store.state.emailParam;
      const paramEmail = params.email;
      if (paramEmail && storedEmail && paramEmail !== storedEmail) {
        console.log("Email mismatch detected - Stored:", storedEmail, "Param:", paramEmail);
        this.$router.push({ name: "Login" });
      }

      console.log("Updated store params from route:", params);
    },
  },
};
</script>

<style scoped>
.no-margin {
  margin-left: 0 !important;
}
.expand {
  margin-left: 90px;
  transition-timing-function: ease-in-out;
  transition-duration: 0.3s;
}
.not-expand {
  margin-left: 340px;
  transition-timing-function: ease-in-out;
  transition-duration: 0.3s;
}
.pinMenu {
  margin-left: 330px;
  transition-timing-function: ease-in-out;
  transition-duration: 0.3s;
}
.min-expand {
  margin-left: 0px;
  transition-timing-function: ease-in-out;
  transition-duration: 0.3s;
}
.in-iframe {
  margin-left: 0px;
  transition-timing-function: ease-in-out;
  transition-duration: 0.3s;
}
#container {
  min-height: 100%;
}
</style>